import React from "react";
import { FaGooglePlay, FaApple, FaStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const AndroidProjects = () => {
  const androidApps = [
    {
      name: "Nicotex Begin",
      link: "https://play.google.com/store/apps/details?id=com.nicotex.begin",
      category: "Health & Wellness",
      image: "/photo5.png",
      rating: 4.8,
      downloads: "100K+",
      description: "Health management app for wellness tracking",
      featured: true,
      icon: <FaGooglePlay />
    },
    {
      name: "Cricket Wickets",
      link: "https://play.google.com/store/apps/details?id=com.cricketwickets",
      category: "Sports",
      image: "/photo1.png",
      rating: 4.5,
      downloads: "50K+",
      description: "Cricket score tracking application",
      icon: <FaGooglePlay />
    },
    {
      name: "Second Income",
      link: "https://play.google.com/store/apps/details?id=com.Second.income",
      category: "Finance",
      image: "/photo2.png",
      rating: 4.3,
      downloads: "25K+",
      description: "Investment and income management platform",
      icon: <FaGooglePlay />
    },
    {
      name: "Property Bazar",
      link: "https://play.google.com/store/apps/details?id=com.propertysbazar",
      category: "Real Estate",
      image: "/photo3.png",
      rating: 4.6,
      downloads: "75K+",
      description: "Real estate marketplace application",
      icon: <FaGooglePlay />
    },
    {
      name: "Ittzy App",
      link: "https://play.google.com/store/apps/details?id=com.ittzyapp.app",
      category: "Utility",
      image: "/photo8.png",
      rating: 4.4,
      downloads: "30K+",
      description: "Productivity and utility application",
      icon: <FaGooglePlay />
    },
    // {
    //   name: "Indirera",
    //   link: "https://play.google.com/store/apps/details?id=com.Indirera",
    //   category: "Real Estate",
    //   image: "/photo6.png",
    //   rating: 4.2,
    //   downloads: "20K+",
    //   description: "Commercial property management",
    //   icon: <FaGooglePlay />
    // },
    // {
    //   name: "Right Human",
    //   link: "https://play.google.com/store/search?q=right+human&c=apps",
    //   category: "E-commerce",
    //   image: "/photo7.png",
    //   rating: 4.7,
    //   downloads: "150K+",
    //   description: "HR management platform",
    //   icon: <FaGooglePlay />
    // },
    {
      name: "AGRIT",
      link: "https://play.google.com/store/apps/details?id=in.app.kisaan&pcampaignid=web_share",
      category: "Agriculture",
      image: "/photo9.png",
      rating: 4.9,
      downloads: "200K+",
      description: "Farmer assistance platform",
      featured: true,
      icon: <FaGooglePlay />
    },
    {
      name: "United Cab Merthyr",
      link: "https://apps.apple.com/bs/app/united-cabs-merthyr/id6756064638",
      category: "Transportation",
      image: "/photo10.jpeg",
      rating: 4.6,
      downloads: "10K+",
      description: "Cab booking service",
      icon: <FaApple />
    },
    {
      name: "United Cab Merthyr For Drivers",
      link: "https://apps.apple.com/bs/app/united-cabs-merthyr-for-driver/id6756536642",
      category: "Transportation",
      image: "/photo10.jpeg",
      rating: 4.5,
      downloads: "5K+",
      description: "Driver companion app",
      icon: <FaApple />
    },
  ];

  return (
    <section className="android-projects-section" aria-label="Mobile Applications Portfolio">
      <div className="section-header">
        <h2 className="section-title">Mobile Apps</h2>
        <p className="section-subtitle">Discover our featured mobile applications</p>
      </div>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={25}
        slidesPerView={3}
        loop={true}
        speed={1200}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          0: { slidesPerView: 1.1 },
          480: { slidesPerView: 1.3 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {androidApps.map((app, index) => (
          <SwiperSlide key={index}>
            <div className="project-card">
              <a
                href={app.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-link"
                aria-label={`View ${app.name} on ${app.icon.type === FaApple ? 'App Store' : 'Play Store'}`}
              >
                {app.featured && (
                  <div className="featured-badge">
                    <FaStar /> Featured
                  </div>
                )}

                <div className="image-container">
                  <div className="image-wrap">
                    <img 
                      src={app.image} 
                      alt={`${app.name} application`}
                      loading="lazy"
                    />
                  </div>
                  
                  {/* <div className="app-metrics">
                    <div className="metric">
                      <FaStar className="metric-icon" />
                      <span className="metric-value">{app.rating}</span>
                    </div>
                    <div className="metric">
                      <span className="metric-value">{app.downloads}</span>
                      <span className="metric-label">Downloads</span>
                    </div>
                  </div> */}
                </div>

                <div className="project-content">
                  <div className="category-badge">{app.category}</div>
                  <h3 className="app-title">{app.name}</h3>
                  <p className="app-description">{app.description}</p>

                  <div className="store-link">
                    {app.icon}
                    <span>View on {app.icon.type === FaApple ? 'App Store' : 'Play Store'}</span>
                  </div>
                </div>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx>{`
        .android-projects-section {
          padding: 80px 20px;
          background: transparent;
          position: relative;
          overflow: hidden;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
          padding: 0 20px;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 800;
          background: linear-gradient(135deg, #22d3ee, #3b82f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }

        .section-subtitle {
          color: #94a3b8;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .project-card {
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          backdrop-filter: blur(10px);
          height: 100%;
          position: relative;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .project-card:hover {
          transform: translateY(-10px) scale(1.02);
          border-color: rgba(34, 211, 238, 0.3);
          box-shadow: 
            0 20px 40px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(34, 211, 238, 0.1);
        }

        .project-link {
          display: block;
          text-decoration: none;
          color: inherit;
          height: 100%;
        }

        .featured-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          padding: 8px 16px;
          background: linear-gradient(135deg, #ffd700, #ff9800);
          color: #020617;
          font-size: 0.8rem;
          font-weight: 700;
          border-radius: 20px;
          display: flex;
          align-items: center;
          gap: 6px;
          z-index: 3;
          box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
          animation: pulse 2s infinite;
        }

        .image-container {
          position: relative;
          padding: 20px;
        }

        .image-wrap {
          width: 100%;
          height: 200px;
          border-radius: 15px;
          overflow: hidden;
          border: 1px solid rgba(255, 255, 255, 0.1);
          margin-bottom: 15px;
        }

        .image-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .project-card:hover .image-wrap img {
          transform: scale(1.05);
        }

        .app-metrics {
          display: flex;
          gap: 15px;
          justify-content: center;
        }

        .metric {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 16px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 20px;
          font-size: 0.85rem;
        }

        .metric-icon {
          color: #ffd700;
        }

        .metric-value {
          color: #f8fafc;
          font-weight: 600;
        }

        .metric-label {
          color: #94a3b8;
        }

        .project-content {
          padding: 0 25px 25px;
        }

        .category-badge {
          display: inline-block;
          padding: 6px 14px;
          background: rgba(34, 211, 238, 0.1);
          color: #22d3ee;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 12px;
          border: 1px solid rgba(34, 211, 238, 0.2);
        }

        .app-title {
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 10px;
          line-height: 1.3;
          color: #f8fafc;
        }

        .app-description {
          font-size: 0.9rem;
          color: #94a3b8;
          line-height: 1.5;
          margin-bottom: 20px;
          min-height: 40px;
        }

        .store-link {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #22d3ee;
          font-weight: 600;
          font-size: 0.95rem;
          padding: 12px 20px;
          background: rgba(34, 211, 238, 0.1);
          border-radius: 12px;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        .project-card:hover .store-link {
          background: rgba(34, 211, 238, 0.15);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(34, 211, 238, 0.2);
        }

        .store-link svg {
          font-size: 1.1rem;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
        }

        /* Swiper Customization */
        :global(.swiper) {
          padding: 20px 10px 50px !important;
        }

        :global(.swiper-button-next),
        :global(.swiper-button-prev) {
          color: #22d3ee;
          background: rgba(255, 255, 255, 0.05);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 1px solid rgba(34, 211, 238, 0.2);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        :global(.swiper-button-next:hover),
        :global(.swiper-button-prev:hover) {
          background: rgba(34, 211, 238, 0.1);
          border-color: #22d3ee;
          transform: scale(1.1);
          box-shadow: 0 0 20px rgba(34, 211, 238, 0.3);
        }

        :global(.swiper-button-next:after),
        :global(.swiper-button-prev:after) {
          font-size: 1.2rem;
        }

        :global(.swiper-pagination-bullet) {
          background: rgba(148, 163, 184, 0.5);
          width: 10px;
          height: 10px;
          opacity: 1;
          transition: all 0.3s ease;
        }

        :global(.swiper-pagination-bullet-active) {
          background: #22d3ee;
          width: 30px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(34, 211, 238, 0.5);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .android-projects-section {
            padding: 60px 15px;
          }

          .section-title {
            font-size: 2rem;
          }

          .section-subtitle {
            font-size: 1rem;
            padding: 0 10px;
          }

          .image-wrap {
            height: 160px;
          }

          .app-title {
            font-size: 1.2rem;
          }

          .store-link {
            font-size: 0.9rem;
            padding: 10px 16px;
          }
        }

        @media (max-width: 480px) {
          .android-projects-section {
            padding: 40px 10px;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .image-wrap {
            height: 140px;
          }

          .project-content {
            padding: 0 20px 20px;
          }

          :global(.swiper-button-next),
          :global(.swiper-button-prev) {
            width: 40px;
            height: 40px;
          }

          :global(.swiper-button-next:after),
          :global(.swiper-button-prev:after) {
            font-size: 1rem;
          }
        }

        @media (max-width: 360px) {
          .image-wrap {
            height: 120px;
          }

          .app-title {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default AndroidProjects;